import { render, staticRenderFns } from "./NewsDetailsFire.vue?vue&type=template&id=05b61263&scoped=true"
import script from "./NewsDetailsFire.vue?vue&type=script&lang=js"
export * from "./NewsDetailsFire.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsFire.vue?vue&type=style&index=0&id=05b61263&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b61263",
  null
  
)

export default component.exports